export default function getLocationFromIp() {
  if (!window.SEARCH.ipapi.key || !window.SEARCH.ipapi.ip || !window.SEARCH.ipapi.baseUrl) {
    console.error('Missing IP API credentials.');
    return;
  }

  const { key, ip, baseUrl } = window.SEARCH.ipapi;

  const urlSearchParams = new URLSearchParams({ key });
  const url = new URL(ip, baseUrl);

  url.search = urlSearchParams.toString();

  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 'success') {
        document.dispatchEvent(
          new CustomEvent('ipapi:success', {
            detail: {
              area: formatAddress(data),
              aroundLatLng: formatCoordinates(data),
              data: data,
            },
          })
        );
      }
    })
    .catch(function (error) {
      console.error(error);
    });

  function formatAddress(data) {
    return `${data.city}, ${data.region}`;
  }

  function formatCoordinates(data) {
    return `${data.lat}, ${data.lon}`;
  }
}
